import { memoizeByAssetSource } from '@exodus/core-selectors/utils/memoize.js'
import { getIncomingOrders } from './utils/incoming-orders.js'

export const resultFunction = (orderSet) =>
  memoizeByAssetSource(({ walletAccount, assetName }) =>
    getIncomingOrders({ assetName, walletAccount, orderSet })
  )

const assetIncomingOrdersSelectorDefinition = {
  id: 'assetIncomingOrders',
  resultFunction,
  dependencies: [{ selector: 'ordersInProgress' }],
}

export default assetIncomingOrdersSelectorDefinition
